export const setTranslations = (data) => {
   return {
      type: "SET_TRANSLATIONS",
      payload: data
   };
};
